import { searchUserIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const HireType = createIcon({
  displayName: 'HireType',
  paths: [
    'M426.667 85.333c-188.501 0-341.333 152.832-341.333 341.333s152.832 341.333 341.333 341.333c78.878 0 151.509-26.761 209.31-71.697l213.858 213.858c20.608 20.608 50.816 23.851 67.499 7.168s13.44-46.891-7.168-67.499l-213.858-213.858c44.932-57.801 71.693-130.432 71.693-209.306 0-188.501-152.832-341.333-341.333-341.333zM426.667 170.667c141.184 0 256 114.816 256 256s-114.816 256-256 256c-141.184 0-256-114.816-256-256s114.816-256 256-256zM406.986 402.256c-25.728-8.294-44.32-32.419-44.32-60.922 0-35.371 28.629-64 64-64s64 28.629 64 64c0 29.97-20.553 55.1-48.346 62.075 51.738 9.178 90.995 54.371 90.995 108.719v42.667c0 11.733-9.472 21.205-21.163 21.205h-170.965c-11.691 0-21.205-9.472-21.205-21.205v-55.68c0-50.287 38.094-91.667 87.003-96.859z'
  ],
  canvasPaths: canvasIconPaths(searchUserIcon)
})
